export const PREVIEW_WIDTH = 340;
export const PREVIEW_MIN_WIDTH = 220;
const PREVIEW_GAP = 8;
const VIEWPORT_MARGIN = 8;

export interface PreviewPlacement {
  side: 'right' | 'left';
  width: number;
  // vertical shift in px, never positive: the card only moves up
  offsetTop: number;
}

interface Rect {
  left: number;
  right: number;
  top: number;
}

// LF360-2015: the preview opens beside the list. It prefers the right, flips to the
// left when the right edge of the window is too close, and when neither side has
// room for the full width it takes the roomier side and narrows to fit.
export const placePreview = (
  anchor: Rect,
  previewHeight: number,
  viewport: { width: number; height: number },
): PreviewPlacement => {
  const spaceRight = viewport.width - anchor.right - PREVIEW_GAP - VIEWPORT_MARGIN;
  const spaceLeft = anchor.left - PREVIEW_GAP - VIEWPORT_MARGIN;

  let side: PreviewPlacement['side'];
  let width = PREVIEW_WIDTH;
  if (spaceRight >= PREVIEW_WIDTH) {
    side = 'right';
  } else if (spaceLeft >= PREVIEW_WIDTH) {
    side = 'left';
  } else {
    side = spaceRight >= spaceLeft ? 'right' : 'left';
    width = Math.min(PREVIEW_WIDTH, Math.max(side === 'right' ? spaceRight : spaceLeft, PREVIEW_MIN_WIDTH));
  }

  const overflowBottom = anchor.top + previewHeight - (viewport.height - VIEWPORT_MARGIN);
  const maxShiftUp = Math.max(anchor.top - VIEWPORT_MARGIN, 0);
  const shiftUp = Math.min(Math.max(overflowBottom, 0), maxShiftUp);

  return { side, width, offsetTop: shiftUp > 0 ? -shiftUp : 0 };
};
